import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { getConfig } from "@jti/fe-common";
import { Conditions, DEPRECATED_Typography as Typography, Loading, useLoyaltyRestrictedContent, } from "@jti/ui";
import { ConditionalView } from "../../components/conditional-view/ConditionalView";
import { ImageBackgroundContainer } from "../../components/image-background-container/ImageBackgroundContainer";
import ContentRestrictionItem from "./ContentRestrictionItem/ContentRestrictionItem";
import "./ContentRestriction.scss";
export const ContentRestriction = ({ title, description, theme, infoLink, infoText, bgImage, bgImageMobile, contentrestrictionlist = [], isInEditor, }) => {
    const { restrictedConditions } = useLoyaltyRestrictedContent();
    const [ageCondition, setAgeCondition] = useState();
    const [noRestrictedConditionDefined, setNoRestrictedConditionDefined] = useState(false);
    const [loginCondition, setLoginCondition] = useState();
    const [purposeCondition, setPurposeCondition] = useState();
    const [deviceCondition, setDeviceCondition] = useState();
    const [criterias, setCriterias] = useState([]);
    const themeColor = theme === "dark" ? "black" : "white";
    useEffect(() => {
        if (restrictedConditions) {
            const ageVerificationCondition = restrictedConditions.find(({ condition }) => condition === Conditions.AGE_VERIFIED);
            const loggedInCondition = restrictedConditions.find(({ condition }) => condition === Conditions.LOGGED_IN);
            const purposeVerifiedCondition = restrictedConditions.find(({ condition }) => condition === Conditions.PURPOSE);
            const deviceVerifiedCondition = restrictedConditions.find(({ condition }) => condition === Conditions.DEVICE_REGISTRATION);
            setAgeCondition(ageVerificationCondition);
            setLoginCondition(loggedInCondition);
            setPurposeCondition(purposeVerifiedCondition);
            setDeviceCondition(deviceVerifiedCondition);
            setNoRestrictedConditionDefined(false);
        }
        else {
            setNoRestrictedConditionDefined(true);
        }
    }, [restrictedConditions?.length]);
    const handlePurposeCondition = (item, purposeIndex) => {
        const loyaltyRestrictionPurposes = getConfig().loyaltyRestrictionPurpose || [];
        let status = false;
        const purposeId = loyaltyRestrictionPurposes[purposeIndex];
        const purposeCondition = restrictedConditions?.find((cond) => cond.condition === Conditions.PURPOSE);
        if (purposeCondition && Array.isArray(purposeCondition.status)) {
            const restrictedCondition = purposeCondition.status.find((cond) => cond.id === purposeId);
            if (restrictedCondition) {
                status = restrictedCondition.accepted;
            }
        }
        return status;
    };
    const handleOtherConditions = (item) => {
        let status = false;
        if (item.type === Conditions.AGE_VERIFIED && typeof ageCondition?.status === "boolean") {
            status = ageCondition?.status || false;
        }
        else if (item.type === Conditions.LOGGED_IN && typeof loginCondition?.status === "boolean") {
            status = loginCondition?.status || false;
        }
        else if (item.type === Conditions.DEVICE_REGISTRATION && typeof deviceCondition?.status === "boolean") {
            status = deviceCondition?.status || false;
        }
        return status;
    };
    useEffect(() => {
        let purposeIndex = 0;
        const criterias = contentrestrictionlist.map((item) => {
            let status;
            if (item.type === Conditions.PURPOSE) {
                status = handlePurposeCondition(item, purposeIndex);
                purposeIndex++;
            }
            else {
                status = handleOtherConditions(item);
            }
            return {
                condition: item.type,
                status,
                name: item.title,
            };
        });
        setCriterias(criterias);
    }, [ageCondition, loginCondition, deviceCondition, restrictedConditions?.length, contentrestrictionlist?.length]);
    return (_jsx(ImageBackgroundContainer, { background: bgImage, mobileBackground: bgImageMobile, children: _jsxs("div", { className: "content-restriction__block", children: [_jsxs("div", { className: "content-restriction__header", children: [_jsx(Typography, { type: "title", className: "content-restriction__title", color: themeColor, weight: "light", "data-testid": "contentRestrictionTitle", children: title }), noRestrictedConditionDefined && (_jsx(Typography, { type: "text", color: themeColor, children: "Author note: You need to configure \"Loyalty Restricted Content Configuration\" CAConfig" })), _jsx(Typography, { type: "text", className: "content-restriction__description", color: themeColor, weight: "light", "data-testid": "contentRestrictionDescription", children: description })] }), ageCondition || loginCondition || purposeCondition || deviceCondition || isInEditor ? (_jsx("div", { className: "content-restriction__criterias-block", "data-testid": "contentRestrictionBlock", children: contentrestrictionlist.map((item, index) => (_jsx(ConditionalView, { condition: !criterias[index]?.status, children: _jsx(ContentRestrictionItem, { type: item.type, title: item.title, infoLink: item.infoLink, dataTestId: item.type, themeColor: themeColor }) }, item.type + index))) })) : (_jsx(Loading, {})), _jsx("button", { className: "content-restriction__button", "data-testid": "contentRestrictionButton", children: _jsxs("a", { href: infoLink, "data-testid": "contentRestrictionButtonText", children: [_jsx(Typography, { type: "medium-text", color: themeColor, weight: "medium", "data-testid": "contentRestrictionButtonText", children: infoText }), _jsx("hr", { className: `content-restriction__button-line content-restriction__button-line--${themeColor}` })] }) })] }) }));
};
//# sourceMappingURL=ContentRestriction.js.map